module.exports = __webpack_public_path__ + "img/demir-celik-sanayi.654e5f59.jpg";